<template>
  <loginForm type="messageLogin" />
</template>

<script>
import loginForm from '@/components/loginForm'
import webviewBack from '@/mixins/webviewBack'

export default {
  name: 'MessageLogin',
  mixins: [webviewBack],
  components: {
    loginForm
  }
}
</script>
